import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function DoloresSection() {
  const dolores = [{
    text: 'Dependes de pastillas todos los días y sigues sintiéndote igual',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-125">
          <path d="M10.5 20.5L3.5 13.5C2.1 12.1 2.1 9.9 3.5 8.5L8.5 3.5C9.9 2.1 12.1 2.1 13.5 3.5L20.5 10.5C21.9 11.9 21.9 14.1 20.5 15.5L15.5 20.5C14.1 21.9 11.9 21.9 10.5 20.5Z" data-id="element-126" />
          <path d="M8.5 8.5L15.5 15.5" data-id="element-127" />
        </svg>
  }, {
    text: 'Gastas demasiado en consultas y medicamentos cada mes',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-128">
          <path d="M20 6H4C2.89 6 2 6.89 2 8V18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V8C22 6.89 21.11 6 20 6Z" data-id="element-129" />
          <path d="M22 12H18C16.89 12 16 12.89 16 14C16 15.11 16.89 16 18 16H22" data-id="element-130" />
        </svg>
  }, {
    text: 'Te despiertas cansado y sin energía real',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-131">
          <rect x="2" y="7" width="16" height="10" rx="2" ry="2" data-id="element-132" />
          <line x1="22" y1="11" x2="22" y2="13" data-id="element-133" />
          <line x1="6" y1="11" x2="6" y2="13" strokeWidth="3" data-id="element-134" />
        </svg>
  }, {
    text: 'Tu presión, azúcar o colesterol no bajan sin importar qué hagas',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-135">
          <polyline points="22 17 13.5 8.5 8.5 13.5 2 7" data-id="element-136" />
          <polyline points="16 17 22 17 22 11" data-id="element-137" />
        </svg>
  }, {
    text: 'Sufres de inflamación, dolor articular o problemas digestivos',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-138">
          <path d="M8.5 14.5A2.5 2.5 0 0011 12c0-1.38-.56-2.63-1.46-3.54C8.63 7.56 8 6.38 8 5c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.38-.63 2.56-1.54 3.46C13.56 9.37 13 10.62 13 12a2.5 2.5 0 002.5 2.5h.5a4.5 4.5 0 014.5 4.5v1a4 4 0 01-4 4H8a4 4 0 01-4-4v-1a4.5 4.5 0 014.5-4.5h.5z" data-id="element-139" />
        </svg>
  }, {
    text: 'Sientes que tu cuerpo se debilita cada año y no sabes cómo frenarlo',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-140">
          <circle cx="12" cy="12" r="10" data-id="element-141" />
          <path d="M8 15h8M9 9h.01M15 9h.01" data-id="element-142" />
        </svg>
  }];
  return <section className="bg-ancestral-cream py-10 md:py-24 text-ancestral-dark" data-id="element-143">
      <div className="container mx-auto px-4" data-id="element-144">
        <div className="max-w-4xl mx-auto" data-id="element-145">
          <FadeIn data-id="element-146">
            <h2 className="text-2xl md:text-4xl font-serif font-bold text-ancestral-green mb-6 md:mb-12 text-center" data-id="element-147">
              ¿Te identificas con alguno de estos problemas?
            </h2>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-8 md:mb-12" data-id="element-148">
            {dolores.map((dolor, idx) => <FadeIn key={idx} delay={0.1 * idx} data-id="element-149">
                <div className="bg-white p-4 md:p-6 rounded-2xl shadow-sm border border-ancestral-gold/20 flex items-center gap-3 md:gap-5 h-full hover:shadow-md transition-shadow" data-id="element-150">
                  <div className="bg-ancestral-cream border border-ancestral-gold/30 text-ancestral-green p-2 md:p-3 rounded-full flex-shrink-0" data-id="element-151">
                    {dolor.icon}
                  </div>
                  <p className="font-bold text-base md:text-lg text-ancestral-dark/90 leading-snug" data-id="element-152">
                    {dolor.text}
                  </p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.6} data-id="element-153">
            <div className="text-center bg-ancestral-green text-ancestral-cream p-6 md:p-8 rounded-2xl shadow-lg" data-id="element-154">
              <p className="text-xl md:text-2xl font-serif font-bold text-ancestral-gold" data-id="element-155">
                No estás solo. Y no es tu culpa.
              </p>
              <p className="text-lg mt-2 font-light" data-id="element-156">
                El sistema actual no está diseñado para sanarte — está diseñado
                para mantenerte comprando.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}